import baseApi from "./baseApi";

const getAll = async () => {
    try {
        const response = baseApi.get('/classes',{
            params: {
                reck: "todos"
            }
        })
        return response
    } catch(error){
        return error;
    }
}
const getAlls = async () => {
    try {
        const response = baseApi.get('/classes',{})
        return response
    } catch(error){
        return error;
    }
}
const filhos = async (id) => {
    try {
        const response = baseApi.get('/classes/filhos',{
            params: {
                id: id
            }
        })
        return response
    } catch(error){
        return error;
    }
}

const create = async (value, id = null) => {
    try {
        const response = baseApi.post('/classes',{
            name: value,
            id_pai: id
        })
        return response
    } catch(error){
        return error;
    }
}

const deleteClasse = async (id) => {
    try {
        const response = baseApi.delete('/classes/' + id)
        return response
    }catch(error){
        return error
    }
}

const show = async (id) => {
    try {
        const response = baseApi.get('/classes/' + id)
        return response
    }catch(error){
        return error
    }
}


const updateClasse = async (id, nome) => {
    try {
        const response = baseApi.put('/classes/' + id, {
                name: nome
        })
        return response
    }catch(error){
        return error
    }
}

export default {
    getAll,
    getAlls,
    filhos,
    create,
    deleteClasse,
    show,
    updateClasse
}